import keymirror from 'js/utils/keymirror';
import { callApi, noSchemaQuerySuccessMutator } from 'js/api';
import { request } from 'js/api/axios';
import { extractApiKeys, spreadApiKeys } from 'js/utils';

export const types = keymirror({
  ...spreadApiKeys('FETCH_CYCLE_TIME_REPORT'),
});

/**
 * params: optional query parameters, e.g. { removed_statuses: '' } to count no status as removed.
 */
export function fetchCycleTimeReport(
  teamId,
  connectorId,
  queryId = null,
  params = {}
) {
  const meta = { queryId };
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.FETCH_CYCLE_TIME_REPORT, types),
        request: (_data, token, currentWorkspaceId) =>
          request.get(
            `/api/workspaces/${currentWorkspaceId}/teams/${teamId}/connectors/${connectorId}/cycle-time-report`,
            {
              params,
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        meta,
        mutators: [undefined, noSchemaQuerySuccessMutator(meta), undefined],
        // schema: SCHEMAS.CYCLE_TIME_REPORT,
      },
      dispatch
    );
  };
}
